











































































































import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
import { CarrierProduct } from '@/modules/CarrierProduct/interfaces/carrier-product'
import AppDialog from '@/components/AppDialog.vue'
import FoldingCard from '@/components/FoldingCard.vue'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'
import CarrierProductCommissionDialog from '@/modules/CarrierProduct/components/CarrierProductCommissionFormDialog.vue'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { CarrierProductCommission } from '@/modules/CarrierProduct/interfaces/carrier-product-commission'
import { deleteCarrierProductCommission } from '@/modules/CarrierProduct/gql/carrier-product.gql'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

@Component({
  components: {
    FoldingCard,
    AppDialog,
    AppSystemInfoCard,
    CarrierProductCommissionDialog
  }
})
export default class CarrierProductDetailCommission extends Vue {
  @Prop({ type: Object as () => CarrierProduct }) readonly carrierProduct!: CarrierProduct

  commissionDialog = {
    show: false,
    title: 'Create Commission Info',
    actionType: 'new',
    commissionType: 'GA'
  }

  deleteCommissionDialog = {
    show: false
  }

  targetCommission: CarrierProductCommission | null = null

  tableColumnGA = [
    { field: 'gaName',
      title: 'GA',
      slots: { default: 'ga' },
      resizable: true,
      sortable: true
    },
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: 'carrier' },
      resizable: true,
      sortable: true
    },
    { field: 'commissionName',
      title: 'Commission Name',
      slots: { default: 'commission_name' },
      resizable: true,
      sortable: true
    },
    { field: 'commission',
      title: 'Commission (%)',
      slots: { default: 'commission' },
      resizable: true,
      sortable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 120 }
  ]

  tableColumnDirect = [
    { field: 'carrierName',
      title: 'Carrier',
      slots: { default: 'carrier' },
      resizable: true,
      sortable: true
    },
    { field: 'commissionName',
      title: 'Commission Name',
      slots: { default: 'commission_name' },
      resizable: true,
      sortable: true
    },
    { field: 'commission',
      title: 'Commission (%)',
      slots: { default: 'commission' },
      resizable: true,
      sortable: true
    },
    { field: 'actions', title: 'Actions', slots: { default: 'action_default' }, fixed: 'right', width: 120 }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  get tableColumn () {
    const { type } = this
    return type === 'ga'
      ? this.tableColumnGA
      : this.tableColumnDirect
  }

  get commissions () {
    const { type } = this
    const { commissions } = this.carrierProduct
    if (type === 'ga') {
      return commissions.filter((commission: CarrierProductCommission) => {
        return commission.gaId !== null
      })
    } else {
      return commissions.filter((commission: CarrierProductCommission) => {
        return commission.gaId === null
      })
    }
  }

  get type () {
    return this.$R.last(this.$route.path.split('/'))
  }

  get tableHeight () {
    const { commissions } = this
    return 32.5 * (commissions.length + 1) > 500
      ? 500
      : 32.5 * (commissions.length + 1)
  }

  showCommissionDialog (e: Event, commission: CarrierProductCommission) {
    e.preventDefault()
    e.stopPropagation()
    const typeText = this.type === 'ga' ? 'GA' : 'Direct'
    if (commission) {
      this.targetCommission = commission
      this.commissionDialog = {
        show: true,
        title: `Edit Commission Info (${typeText})`,
        actionType: 'edit',
        commissionType: this.type
      }
    } else {
      this.commissionDialog = {
        show: true,
        title: `Create Commission Info (${typeText})`,
        actionType: 'new',
        commissionType: this.type
      }
    }
  }

  showDeleteDialog (e: Event, commission: CarrierProductCommission) {
    e.preventDefault()
    e.stopPropagation()
    this.targetCommission = commission
    this.deleteCommissionDialog.show = true
  }

  async deleteCommissionConfirm () {
    await this.deleteCommissionPost()
    this.onSuccess()
  }

  async deleteCommissionPost () {
    if (!this.targetCommission) {
      return
    }
    const { id } = this.targetCommission
    this.deleteCommissionDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteCarrierProductCommission,
        variables: {
          commissionId: Number(id)
        }
      })

      const res = result.data.deletePolicyById
      if (res) {
        showNotification({
          msg: 'Delete Commission successfully',
          type: SnackType.Success
        })
        this.targetCommission = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
  }

  routeToGADetail (gaId: number) {
    this.$router.push({
      name: 'GeneralAgentDetailDetail',
      params: {
        id: gaId + ''
      }
    })
  }

  routeToCarrierDetail (carrierId: number) {
    this.$router.push({
      name: 'CarrierDetailDetail',
      params: {
        id: carrierId + ''
      }
    })
  }

  @Emit('success')
  onSuccess () {
    this.commissionDialog.show = false
  }

  onPost () {
    this.commissionDialog.show = false
  }
}
